import { Icon } from "@circle-react-shared/Icon";
import { Switch as SwitchComponent } from "@headlessui/react-v2";
import noop from "lodash/noop";
import type { ElementType } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

export interface SwitchProps {
  as?: ElementType<any>;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export const Switch = ({
  as = "button",
  checked = false,
  onChange = noop,
  disabled = false,
}: SwitchProps) => (
  <SwitchComponent
    as={as}
    checked={checked}
    onChange={onChange}
    disabled={disabled}
    className={classNames(
      "disabled:bg-disabled relative mb-0 flex h-4 w-6 items-center rounded-full transition-colors disabled:cursor-not-allowed",
      {
        "bg-toggle-checked": checked,
        "bg-toggle-unchecked": !checked,
      },
    )}
  >
    <span
      className={classNames(
        "text-darkest inline-block size-2.5 rounded-full transition-transform",
        {
          "bg-toggle-circle-checked translate-x-2.5": checked,
          "bg-toggle-circle-unchecked translate-x-1": !checked,
        },
      )}
    >
      <Icon
        type="10-circle-check"
        size={10}
        style={{ width: "auto", display: "block" }}
        className={classNames("text-selector-active transition-opacity", {
          "opacity-30": checked && disabled,
          "opacity-100": checked && !disabled,
          "opacity-0": !checked,
        })}
        useWithStrokeCurrentColor
      />
    </span>
  </SwitchComponent>
);
